import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BrandProvider } from "@/context/BrandContext";
import { TasksProvider } from "@/context/TasksContext";
import { DemoProvider } from "@/context/DemoContext";
import { AppLayout } from "@/components/AppLayout";
import { DemoTour } from "@/components/DemoTour";
import Home from "@/pages/Home";
import Asistente from "@/pages/Asistente";
import Visitas from "@/pages/Visitas";
import Agenda from "@/pages/Agenda";
import Alquileres from "@/pages/Alquileres";
import Portales from "@/pages/Portales";
import Propiedades from "@/pages/Propiedades";
import Tareas from "@/pages/Tareas";
import Configuracion from "@/pages/Configuracion";
import EsquemaDatos from "@/pages/EsquemaDatos";
import RecorridoDemo from "@/pages/RecorridoDemo";

function App() {
  return (
    <BrandProvider>
      <TasksProvider>
        <DemoProvider>
          <BrowserRouter>
            <AppLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/asistente" element={<Asistente />} />
                <Route path="/visitas" element={<Visitas />} />
                <Route path="/agenda" element={<Agenda />} />
                <Route path="/alquileres" element={<Alquileres />} />
                <Route path="/portales" element={<Portales />} />
                <Route path="/propiedades" element={<Propiedades />} />
                <Route path="/tareas" element={<Tareas />} />
                <Route path="/configuracion" element={<Configuracion />} />
                <Route path="/esquema-datos" element={<EsquemaDatos />} />
                <Route path="/recorrido-demo" element={<RecorridoDemo />} />
              </Routes>
            </AppLayout>
            <DemoTour />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </DemoProvider>
      </TasksProvider>
    </BrandProvider>
  );
}

export default App;
